import React, { useEffect } from 'react';
import styles from './DeleteBtn.module.scss';
import { Button, IconButton } from '@mui/material';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { resetDeleteItem } from '../../../redux/slices/app.slice';
import { deleteItem } from '../../../redux/actions/app/deleteItem';
import { Delete, Lock, LockOpen } from '@mui/icons-material';
const DeleteBtn = ({ isIcon, onDelete = () => {}, successText, type, id, confirmTitle, confirmText, status }) => {
  const getStatusData = () => {
    switch (status) {
      case 'DELETED':
        return { textBtn: 'Удалить', color: 'error', colorHex: '#d32f2f', variant: 'outlined', icon: 'error', iconBtn: <Delete color="error" />, iconColorHex: '#d32f2f' };
      case 'BLOCKED':
        return { textBtn: 'Заблокировать', color: 'error', colorHex: '#d32f2f', variant: 'contained', icon: 'error', iconBtn: <LockOpen color="success" />, iconColorHex: '#2e7d32' };
      case 'ACTIVE':
        return { textBtn: 'Разблокировать', color: 'primary', colorHex: '#1976d2', variant: 'contained', icon: 'info', iconBtn: <Lock color="error" />, iconColorHex: '#d32f2f' };
    }
  };
  const { iconColorHex, iconBtn, icon, variant, textBtn, color, colorHex } = getStatusData();
  const {
    deleteItem: { data: deleteItemData, loading: deleteItemLoading },
  } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  useEffect(() => {
    if (deleteItemData?.status == status && deleteItemData?.id == id) {
      toast.success(successText);
      onDelete();

      dispatch(resetDeleteItem());
    }
  }, [deleteItemData]);
  const handleClick = () => {
    Swal.fire({
      title: confirmTitle,
      text: confirmText,
      icon: icon,
      showCancelButton: true,

      cancelButtonColor: 'rgba(0, 0, 0, 0.6)',
      confirmButtonColor: colorHex,
      confirmButtonText: textBtn,
      cancelButtonText: 'Отмена',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteItem({
            type,
            id,
            status,
          }),
        );
      }
    });
  };
  return (
    <>
      {isIcon ? (
        <IconButton sx={{ borderRadius: '4px', border: `1px solid ${iconColorHex}` }} onClick={handleClick}>
          {iconBtn}
        </IconButton>
      ) : (
        <Button onClick={handleClick} color={color} variant={variant} sx={{ display: 'flex' }} size="medium">
          {textBtn}
        </Button>
      )}
    </>
  );
};

export default DeleteBtn;
